import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "settings-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 2,
  class: "settings"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content__buttons" }
const _hoisted_6 = { class: "content__buttons__row" }
const _hoisted_7 = {
  key: 0,
  class: "content__buttons__row"
}

import { onBeforeMount, ref } from 'vue'

import RootPageLayout from '@/app/components/RootPageLayout.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import InfoDeleteAccount from '@/app/components/settings/InfoDeleteAccount.vue'
import ReadingStreakWidgetFull16464 from '@/app/components/streaks/ReadingStreakWidgetFull16464.vue'

import { SettingsView } from '@/models/settings'
import { getEmail } from '@/services/auth'
import { streaks16464Variant } from '@/services/ab'


export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const settingsView = ref(new SettingsView())
const email = ref<string | null>(null)

function title16464(): string {
  return streaks16464Variant() === 'B' ? 'Profile' : 'Settings'
}

async function updateNotifyNewRelease(value: boolean): Promise<void> {
  await settingsView.value.toggleNotificationSetting(
    'notify_new_release',
    value,
  )
}

async function updateNotifyStreaks16464(value: boolean): Promise<void> {
  await settingsView.value.toggleNotificationSetting(
    'notify_reading_streaks',
    value,
  )
}

onBeforeMount(async () => {
  await settingsView.value.init()
  email.value = getEmail()
})

return (_ctx: any,_cache: any) => {
  const _component_LoadingError = _resolveComponent("LoadingError")!

  return (_openBlock(), _createBlock(RootPageLayout, {
    title: title16464()
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (settingsView.value.isLoading)
            ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
            : _createCommentVNode("", true),
          (settingsView.value.isError)
            ? (_openBlock(), _createBlock(_component_LoadingError, { key: 1 }))
            : _createCommentVNode("", true),
          (settingsView.value.isLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("ul", { class: "sidebar" }, [
                  _createElementVNode("li", { class: "sidebar__item" }, [
                    _createElementVNode("div", { class: "active-bar" }),
                    _createTextVNode(" Account "),
                    _createElementVNode("span", { class: "spacer" }),
                    _createElementVNode("span", { class: "iconfont iarrow active-arrow" })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  (settingsView.value.readingStreakData16464)
                    ? (_openBlock(), _createBlock(ReadingStreakWidgetFull16464, {
                        key: 0,
                        class: "content__reading-streak16464",
                        streakData: settingsView.value.readingStreakData16464
                      }, null, 8, ["streakData"]))
                    : _createCommentVNode("", true),
                  _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Device Notifications", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("p", null, "Control notifications on devices where you use Shortform", -1)),
                  _createElementVNode("ul", _hoisted_5, [
                    _createElementVNode("li", _hoisted_6, [
                      _createVNode(ToggleButton, {
                        class: "toggle-button",
                        value: 
                    settingsView.value.notificationSettings?.notify_new_release ||
                    false
                  ,
                        "onUpdate:value": updateNotifyNewRelease
                      }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode(" New summary announcements ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    (_unref(streaks16464Variant)() === 'B')
                      ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                          _createVNode(ToggleButton, {
                            class: "toggle-button",
                            value: 
                    settingsView.value.notificationSettings?.notify_reading_streaks ||
                    false
                  ,
                            "onUpdate:value": updateNotifyStreaks16464
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode(" Notifications about streaks ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "settings-email" }, "Account Email", -1)),
                  _createElementVNode("p", null, _toDisplayString(email.value), 1),
                  _createVNode(InfoDeleteAccount)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})